export default __webpack_public_path__ + "static/media/4.de0af7e5.jpg";